import {createContext, use} from 'react'

export const RelayLiveUpdatesContext = createContext(true)

export function useRelayLiveUpdatesEnabled(): boolean {
  return use(RelayLiveUpdatesContext)
}
